(() => {
  const findEasySellTrigger = () =>
    document.querySelector('.es-popup-button-cart') ||
    document.querySelector('.es-popup-button-product') ||
    document.querySelector('#es-popup-button') ||
    document.querySelector('.es-popup-button') ||
    document.querySelector('[class*="es-popup-button"]') ||
    document.querySelector('[href="es-form-hook"]') ||
    document.querySelector('#es-form-hook');

  const openEasySellForm = () => {
    const trigger = findEasySellTrigger();
    if (!trigger) return false;
    trigger.click();
    return true;
  };

  const fold = (s) =>
    String(s || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase();

  const fireNative = (el, type) => {
    el.dispatchEvent(new Event(type, { bubbles: true }));
  };

  const getEasySellVm = () => {
    const form = document.querySelector('form.es-form');
    return (form && form.__vue__) || null;
  };

  const matchVueOption = (options, typed) => {
    const needle = fold(typed);
    if (!needle || !options || !options.length) return null;
    let match = options.find((o) => fold(o.label) === needle || fold(o.value) === needle);
    if (!match) {
      match = options.find((o) => {
        const label = fold(o.label);
        return label.includes(needle) || needle.includes(label);
      });
    }
    return match || null;
  };

  const setSelectValue = (select, typed) => {
    const raw = (typed || '').trim();
    if (!raw) {
      select.value = '';
      fireNative(select, 'input');
      fireNative(select, 'change');
      return false;
    }

    const needle = fold(raw);
    let match = [...select.options].find((o) => {
      if (!o.value) return false;
      const label = fold(o.textContent);
      return label === needle || fold(o.value) === needle;
    });

    if (!match) {
      match = [...select.options].find((o) => {
        if (!o.value) return false;
        const label = fold(o.textContent);
        return label.includes(needle) || needle.includes(label);
      });
    }

    if (!match) {
      match = document.createElement('option');
      match.value = raw;
      match.textContent = raw;
      select.appendChild(match);
    }

    select.disabled = false;
    match.selected = true;
    select.value = match.value;
    fireNative(select, 'input');
    fireNative(select, 'change');
    try {
      select.dispatchEvent(new InputEvent('input', { bubbles: true, data: raw }));
    } catch (_) {}
    return true;
  };

  // EasySell validates Vuex field.model — native <select> value alone is ignored.
  const syncVueSelectField = (fieldName, typed, { loadCities } = {}) => {
    const vm = getEasySellVm();
    if (!vm || !vm.$store) return false;
    const store = vm.$store;
    const field = (store.state.form.fields || []).find((f) => f.value === fieldName);
    if (!field) return false;

    const raw = (typed || '').trim();
    if (!raw) {
      if (typeof vm.$delete === 'function') vm.$delete(field, 'model');
      else delete field.model;
      return false;
    }

    const matched = matchVueOption(field.options, raw);
    const model = matched || { label: raw, value: raw };
    vm.$set(field, 'model', model);
    field.hasError = false;
    field.error = '';

    try {
      if (fieldName === 'province' && typeof vm.onProvinceChange === 'function') {
        vm.onProvinceChange(model);
      } else if (typeof vm.onSelectFieldChange === 'function') {
        vm.onSelectFieldChange(field);
      }
    } catch (_) {}

    if (loadCities && fieldName === 'province') {
      store.dispatch('shipping/updateShippingOnProvinceChange', model).catch(() => {});
    }

    try {
      store.commit('form/SET_ERRORS', []);
    } catch (_) {}

    return true;
  };

  const clearFieldErrors = (select) => {
    const wrap = select.closest('.es-input-container, .es-group, .es-field, [class*="es-"]');
    if (!wrap) return;
    wrap.classList.remove('es-error', 'has-error', 'is-invalid', 'error');
    wrap.querySelectorAll('.es-errors, .es-error-message, .error-message, .es-field-error, [class*="error-message"]').forEach((el) => {
      if (/required|obligator/i.test(el.textContent || '')) el.textContent = '';
    });
  };

  const fieldNameFromSelect = (select) => {
    if (!select) return '';
    if (select.name === 'province' || select.id === 'es-province') return 'province';
    if (select.name === 'city' || select.id === 'es-city') return 'city';
    return select.name || '';
  };

  const syncFreeTypePair = (input) => {
    const id = input.dataset.for;
    const select =
      (id && document.querySelector(`select#${CSS.escape(id)}, select[name="${CSS.escape(id)}"]`)) ||
      (input.parentElement && input.parentElement.querySelector('select'));
    if (!select) return;
    const name = fieldNameFromSelect(select);
    setSelectValue(select, input.value);
    syncVueSelectField(name, input.value, { loadCities: name === 'province' });
    if (input.value.trim()) clearFieldErrors(select);
  };

  const syncAllFreeTypeFields = () => {
    document.querySelectorAll('input.microcasa-es-text').forEach((input) => syncFreeTypePair(input));
  };

  const getVueFieldOptions = (fieldName) => {
    const vm = getEasySellVm();
    if (!vm || !vm.$store) return [];
    const field = (vm.$store.state.form.fields || []).find((f) => f.value === fieldName);
    return (field && field.options) || [];
  };

  const optionListFromSelect = (select, fieldName) => {
    const vueOpts = getVueFieldOptions(fieldName);
    if (vueOpts.length) {
      return vueOpts.map((o) => ({
        label: String(o.label || o.value || ''),
        value: String(o.value || o.label || ''),
      }));
    }
    return [...select.options]
      .filter((o) => o.value)
      .map((o) => ({ label: (o.textContent || '').trim(), value: o.value }));
  };

  const wireFreeTypeSelect = (select, placeholder) => {
    if (!select || select.tagName !== 'SELECT') return;
    if (select.dataset.microcasaFreetype === '1') return;

    const parent = select.parentElement;
    if (!parent) return;

    const fieldName = fieldNameFromSelect(select);
    const existing = parent.querySelector(`input.microcasa-es-text[data-for="${select.id || select.name}"]`);
    if (existing) {
      select.dataset.microcasaFreetype = '1';
      return;
    }

    select.dataset.microcasaFreetype = '1';
    select.classList.add('microcasa-es-select-hidden');
    select.setAttribute('aria-hidden', 'true');
    select.tabIndex = -1;
    select.disabled = false;

    if (!parent.classList.contains('microcasa-es-combo')) {
      parent.classList.add('microcasa-es-combo');
    }

    const input = document.createElement('input');
    input.type = 'text';
    input.className = 'es-input es-text microcasa-es-text';
    input.placeholder = placeholder || select.getAttribute('placeholder') || '';
    input.autocomplete = 'off';
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-label', placeholder || select.name);
    input.dataset.for = select.id || select.name;
    input.required = false;

    const list = document.createElement('ul');
    list.className = 'microcasa-es-suggest';
    list.setAttribute('role', 'listbox');
    list.hidden = true;

    const selected = select.options[select.selectedIndex];
    if (selected && selected.value) {
      input.value = (selected.textContent || '').trim();
    }

    const closeList = () => {
      list.hidden = true;
      input.setAttribute('aria-expanded', 'false');
    };

    const pickOption = (opt) => {
      input.value = opt.label;
      setSelectValue(select, opt.label);
      syncVueSelectField(fieldName, opt.label, { loadCities: fieldName === 'province' });
      clearFieldErrors(select);
      closeList();
      if (fieldName === 'province') {
        // City options reload after province — clear stale city text
        const cityInput = document.querySelector('input.microcasa-es-text[data-for="city"], input.microcasa-es-text[data-for="es-city"]');
        if (cityInput && !cityInput.value.trim()) {
          /* keep empty for user to search */
        }
        applyMicrocasaShipping();
      }
    };

    const renderSuggestions = () => {
      const opts = optionListFromSelect(select, fieldName);
      const needle = fold(input.value);
      const matches = !needle
        ? opts.slice(0, 12)
        : opts.filter((o) => fold(o.label).includes(needle) || fold(o.value).includes(needle)).slice(0, 12);

      list.innerHTML = '';
      if (!matches.length) {
        closeList();
        return;
      }
      matches.forEach((opt, idx) => {
        const li = document.createElement('li');
        li.className = 'microcasa-es-suggest__item';
        li.setAttribute('role', 'option');
        li.dataset.index = String(idx);
        li.textContent = opt.label;
        li.addEventListener('mousedown', (e) => {
          e.preventDefault();
          pickOption(opt);
        });
        list.appendChild(li);
      });
      list.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };

    const sync = () => {
      syncFreeTypePair(input);
      renderSuggestions();
    };

    input.addEventListener('input', sync);
    input.addEventListener('change', () => syncFreeTypePair(input));
    input.addEventListener('focus', renderSuggestions);
    input.addEventListener('click', renderSuggestions);
    input.addEventListener('keydown', (e) => {
      const items = [...list.querySelectorAll('.microcasa-es-suggest__item')];
      const active = list.querySelector('.is-active');
      let idx = items.indexOf(active);
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (list.hidden) renderSuggestions();
        idx = Math.min(items.length - 1, idx + 1);
        items.forEach((el, i) => el.classList.toggle('is-active', i === idx));
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        idx = Math.max(0, idx - 1);
        items.forEach((el, i) => el.classList.toggle('is-active', i === idx));
      } else if (e.key === 'Enter') {
        if (!list.hidden && items[idx]) {
          e.preventDefault();
          items[idx].dispatchEvent(new Event('mousedown'));
        } else {
          syncFreeTypePair(input);
          closeList();
        }
      } else if (e.key === 'Escape') {
        closeList();
      }
    });
    input.addEventListener('blur', () => {
      setTimeout(() => {
        syncFreeTypePair(input);
        closeList();
      }, 150);
    });

    if (select.name === 'city' || select.id === 'es-city') {
      const optWatch = new MutationObserver(() => {
        if (input.value.trim()) syncFreeTypePair(input);
      });
      optWatch.observe(select, { childList: true });
    }

    parent.insertBefore(input, select);
    parent.insertBefore(list, select);
  };

  const cartQualifiesFreeShip = (store) => {
    try {
      const items = (((store.state.cart || {}).cart || {}).items) || [];
      return items.some((it) => {
        const title = String(it.variant_title || it.title || '');
        return /4\s*saci/i.test(title) || /6\s*saci/i.test(title);
      });
    } catch (_) {
      return false;
    }
  };

  const applyMicrocasaShipping = () => {
    const rates = window.__MICROCASA_SHIP_RATES;
    if (!rates) return;
    const vm = getEasySellVm();
    if (!vm || !vm.$store) return;
    const store = vm.$store;

    const free = cartQualifiesFreeShip(store);
    const chosen = free ? rates.free : rates.paid;
    window.ES_SHIPPING_OPTIONS_OVERWRITE = [chosen];

    try {
      if (window.EASYSELL_CONFIG && window.EASYSELL_CONFIG.settings) {
        window.EASYSELL_CONFIG.settings.shippingConfig = {
          enabled: true,
          type: 'custom',
          customRates: [rates.paid, rates.free],
        };
      }
    } catch (_) {}

    try {
      store.commit('shipping/SET_SHIPPING_DISCOUNT', null);
      store.commit('shipping/SET_SHIPPING_CONFIG', {
        enabled: true,
        type: 'custom',
        customRates: [rates.paid, rates.free],
      });
      store.commit('shipping/SET_OPTIONS', [chosen]);
      store.commit('shipping/SET_SELECTED_OPTION', chosen);
    } catch (_) {}
  };

  const liberateEasySellAddressFields = () => {
    wireFreeTypeSelect(document.querySelector('select#es-province, select[name="province"]'), 'Caută județul...');
    wireFreeTypeSelect(document.querySelector('select#es-city, select[name="city"]'), 'Caută localitatea...');
  };

  const patchEasySellValidate = () => {
    const vm = getEasySellVm();
    if (!vm || vm.__microcasaPatched) return;
    vm.__microcasaPatched = true;
    const origValidate = vm.validate && vm.validate.bind(vm);
    const origSubmit = vm.validateAndSubmit && vm.validateAndSubmit.bind(vm);
    if (origValidate) {
      vm.validate = function patchedValidate() {
        syncAllFreeTypeFields();
        applyMicrocasaShipping();
        return origValidate();
      };
    }
    if (origSubmit) {
      vm.validateAndSubmit = function patchedValidateAndSubmit() {
        syncAllFreeTypeFields();
        applyMicrocasaShipping();
        return origSubmit.apply(this, arguments);
      };
    }
  };

  const watchEasySellForm = () => {
    liberateEasySellAddressFields();
    patchEasySellValidate();
    applyMicrocasaShipping();
    const root = document.body;
    if (!root || root.dataset.microcasaEsWatch === '1') return;
    root.dataset.microcasaEsWatch = '1';
    const mo = new MutationObserver(() => {
      liberateEasySellAddressFields();
      patchEasySellValidate();
      applyMicrocasaShipping();
    });
    mo.observe(root, { childList: true, subtree: true });

    // Before EasySell submit, force-sync typed values into Vuex field.model
    document.addEventListener(
      'click',
      (e) => {
        const btn = e.target && e.target.closest && e.target.closest('.es-modal .es-button, .es-form .es-button, .es-cta-btn, button.es-cta');
        if (!btn) return;
        syncAllFreeTypeFields();
        applyMicrocasaShipping();
      },
      true
    );
  };

  const initGallery = (root) => {
    const stage = root.querySelector('[data-gallery]');
    if (!stage) return;
    const figures = [...stage.querySelectorAll('[data-gallery-item]')];
    const thumbs = [...root.querySelectorAll('[data-thumb]')];

    const show = (index) => {
      figures.forEach((fig, i) => fig.classList.toggle('is-active', i === index));
      thumbs.forEach((btn, i) => btn.classList.toggle('is-active', i === index));
      const active = figures[index];
      if (!active) return;
      const gif = active.querySelector('img[data-gif="true"]');
      if (gif && gif.src) {
        const src = gif.src;
        gif.src = '';
        gif.src = src;
      }
      const video = active.querySelector('video');
      if (video) {
        video.currentTime = 0;
        video.play().catch(() => {});
      }
    };

    thumbs.forEach((btn) => {
      btn.addEventListener('click', () => show(Number(btn.dataset.thumb)));
    });
  };

  // After EasySell order success → Romanian confirmation page
  const watchThankYouRedirect = () => {
    if (document.body.dataset.microcasaTyWatch === '1') return;
    document.body.dataset.microcasaTyWatch = '1';
    let redirected = false;
    const go = () => {
      if (redirected) return;
      if (/\/pages\/comanda-confirmata/i.test(location.pathname)) return;
      redirected = true;
      window.location.href = '/pages/comanda-confirmata';
    };
    const check = () => {
      const root =
        document.querySelector('.es-thankyou, .es-thank-you, [class*="thankyou"], [class*="thank-you"]') ||
        document.querySelector('.es-modal');
      if (!root) return;
      const text = root.innerText || '';
      if (/Mulțumim|Multumim|Thank You|comanda (ta )?este înregistr|comanda (ta )?a fost/i.test(text)) {
        // Prefer EasySell custom redirect; hard-nav if still on product after success UI
        setTimeout(go, 1200);
      }
    };
    const mo = new MutationObserver(() => check());
    mo.observe(document.documentElement, { childList: true, subtree: true });
  };

  document.querySelectorAll('.pdp').forEach(initGallery);
  watchEasySellForm();
  initPackPickers();
  watchThankYouRedirect();

  function initPackPickers() {
    document.querySelectorAll('[data-pack-picker]').forEach((picker) => {
      const root = picker.closest('.pdp') || document;
      const form = root.querySelector('[data-product-form]');
      const hidden = form && form.querySelector('[data-variant-id]');
      const priceEl = root.querySelector('[data-price]');
      const compareEl = root.querySelector('[data-compare]');
      const saveEl = root.querySelector('[data-pack-save]');
      const badge = root.querySelector('.price-badge');
      const cta = root.querySelector('[data-microcasa-cod-cta]');

      const shipEl = root.querySelector('[data-ship-amount]');
      const courierEl = root.querySelector('[data-courier-amount]');

      const apply = (btn) => {
        if (!btn) return;
        picker.querySelectorAll('[data-pack-option]').forEach((opt) => {
          const on = opt === btn;
          opt.classList.toggle('is-selected', on);
          opt.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        if (hidden) hidden.value = btn.dataset.variantId || '';
        if (priceEl && btn.dataset.variantPrice) priceEl.textContent = btn.dataset.variantPrice;
        if (compareEl) {
          if (btn.dataset.variantCompare) {
            compareEl.textContent = btn.dataset.variantCompare;
            compareEl.hidden = false;
          } else {
            compareEl.textContent = '';
            compareEl.hidden = true;
          }
        }
        if (saveEl) {
          if (btn.dataset.variantSave) {
            const raw = btn.dataset.variantSave;
            saveEl.textContent = raw.toLowerCase().includes('reducere') ? raw : ('reducere ' + raw);
            saveEl.hidden = false;
          } else {
            saveEl.textContent = '';
            saveEl.hidden = true;
          }
        }
        if (badge && btn.dataset.variantPrice) badge.textContent = btn.dataset.variantPrice;
        if (shipEl) {
          const ship = Number(btn.dataset.variantShip);
          shipEl.textContent = ship === 0 || btn.dataset.freeShip === 'true' ? 'GRATUIT' : ship + ' lei';
        }
        if (courierEl && btn.dataset.variantTotal) {
          courierEl.textContent = btn.dataset.variantTotal + ' lei';
        }
        if (cta) cta.disabled = false;
        if (hidden) {
          hidden.dispatchEvent(new Event('change', { bubbles: true }));
          hidden.dispatchEvent(new Event('input', { bubbles: true }));
        }
        if (form) form.dispatchEvent(new Event('change', { bubbles: true }));
      };

      picker.querySelectorAll('[data-pack-option]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          apply(btn);
        });
        if (btn.classList.contains('is-selected')) apply(btn);
      });
    });
  }

  function openCodWithRetry() {
    try {
      if (window.MICROCASA_META && typeof window.MICROCASA_META.trackInitiateCheckout === 'function') {
        window.MICROCASA_META.trackInitiateCheckout();
      }
    } catch (_) {}
    if (openEasySellForm()) {
      liberateEasySellAddressFields();
      applyMicrocasaShipping();
      return true;
    }
    let tries = 0;
    const timer = setInterval(() => {
      tries += 1;
      liberateEasySellAddressFields();
      applyMicrocasaShipping();
      if (openEasySellForm() || tries > 24) clearInterval(timer);
    }, 150);
    return !!findEasySellTrigger();
  }

  // Event delegation backup (FB in-app / late EasySell DOM)
  document.addEventListener(
    'click',
    (e) => {
      const packBtn = e.target && e.target.closest && e.target.closest('[data-pack-option]');
      if (packBtn) {
        const picker = packBtn.closest('[data-pack-picker]');
        if (!picker) return;
        e.preventDefault();
        const root = picker.closest('.pdp') || document;
        const form = root.querySelector('[data-product-form]');
        const hidden = form && form.querySelector('[data-variant-id]');
        const priceEl = root.querySelector('[data-price]');
        const compareEl = root.querySelector('[data-compare]');
        const saveEl = root.querySelector('[data-pack-save]');
        const badge = root.querySelector('.price-badge');
        const cta = root.querySelector('[data-microcasa-cod-cta]');
        picker.querySelectorAll('[data-pack-option]').forEach((opt) => {
          const on = opt === packBtn;
          opt.classList.toggle('is-selected', on);
          opt.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        if (hidden) {
          hidden.value = packBtn.dataset.variantId || '';
          hidden.dispatchEvent(new Event('change', { bubbles: true }));
        }
        if (priceEl && packBtn.dataset.variantPrice) priceEl.textContent = packBtn.dataset.variantPrice;
        if (compareEl) {
          if (packBtn.dataset.variantCompare) {
            compareEl.textContent = packBtn.dataset.variantCompare;
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
        if (saveEl) {
          if (packBtn.dataset.variantSave) {
            saveEl.textContent = 'reducere ' + packBtn.dataset.variantSave.replace(/^reducere\s+/i, '');
            saveEl.hidden = false;
          } else saveEl.hidden = true;
        }
        if (badge && packBtn.dataset.variantPrice) badge.textContent = packBtn.dataset.variantPrice;
        const shipEl = root.querySelector('[data-ship-amount]');
        const courierEl = root.querySelector('[data-courier-amount]');
        if (shipEl) {
          const ship = Number(packBtn.dataset.variantShip);
          shipEl.textContent =
            ship === 0 || packBtn.dataset.freeShip === 'true' ? 'GRATUIT' : ship + ' lei';
        }
        if (courierEl && packBtn.dataset.variantTotal) {
          courierEl.textContent = packBtn.dataset.variantTotal + ' lei';
        }
        if (cta) cta.disabled = false;
        return;
      }

      const cta = e.target && e.target.closest && e.target.closest('[data-microcasa-cod-cta]');
      if (!cta) return;
      e.preventDefault();
      e.stopPropagation();
      if (!openCodWithRetry()) {
        // Fallback: native add-to-cart if EasySell button missing
        const form = cta.closest('form') || document.querySelector('[data-product-form]');
        if (form) {
          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      }
    },
    true
  );
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    form.addEventListener('change', (e) => {
      const input = e.target;
      if (input.matches('input[type="radio"][name="id"]')) {
        const hidden = form.querySelector('[data-variant-id]');
        if (hidden) hidden.value = input.value;
        const price = document.querySelector('[data-price]');
        const compare = document.querySelector('[data-compare]');
        if (price && input.dataset.variantPrice) price.textContent = input.dataset.variantPrice;
        if (compare) {
          if (input.dataset.variantCompare) {
            compare.textContent = input.dataset.variantCompare;
            compare.hidden = false;
          } else {
            compare.hidden = true;
          }
        }
      }
    });

    form.addEventListener('submit', async (e) => {
      if (findEasySellTrigger() || (window.EASYSELL_CONFIG && window.EASYSELL_CONFIG.active)) {
        e.preventDefault();
        openCodWithRetry();
        return;
      }

      if (!window.fetch) return;
      e.preventDefault();
      const btn = form.querySelector('[data-add-to-cart], button[type="submit"]');
      if (btn) btn.disabled = true;
      try {
        const body = new FormData(form);
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body,
        });
        if (!res.ok) throw new Error('add failed');
        window.location.href = '/cart';
      } catch (_) {
        form.submit();
      } finally {
        if (btn) btn.disabled = false;
      }
    });
  });
})();
